import { render, staticRenderFns } from "./domiciliosVip.vue?vue&type=template&id=1e551df7&"
import script from "./domiciliosVip.vue?vue&type=script&lang=js&"
export * from "./domiciliosVip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports